import React, { useState, useEffect, useCallback } from 'react'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import Dropdown from '@active/react-ui/Dropdown'
import MenuItemList from '@active/react-ui/MenuItemList'
import MenuItem from '@active/react-ui/MenuItem'
import FormFieldError from '@active/react-ui/FormFieldError'

import { withI18n } from '@active/react-utils/i18n'

import {
  monthData, yearData, currentYear, currentMonth,
} from './data/expireDate'

const ExpiredDateInput = withI18n(({
  name,
  value,
  onChange,
  onBlur,
  registerValidate,
  hasError,
  i18n,
}) => {
  const [state, setState] = useState({ ...value })

  useEffect(() => {
    registerValidate(val => {
      const expiredMonthResult = val.expiredMonth ? undefined : i18n('passport.lib.components.newCreditCard.validate.month')
      const expiredYearResult = val.expiredYear ? undefined : i18n('passport.lib.components.newCreditCard.validate.year')

      if (val.expiredYear && `${currentYear}` === `${val.expiredYear}`
          && val.expiredMonth && currentMonth > val.expiredMonth
      ) {
        return i18n('passport.lib.components.error.validate.month.invalidate')
      }

      return (
        (expiredMonthResult || expiredYearResult) && {
          expiredMonth: expiredMonthResult,
          expiredYear: expiredYearResult,
        }
      )
    })
  }, [i18n, registerValidate])

  const handleMonthChange = useCallback(expiredMonth => {
    const updatedState = {
      ...state,
      expiredMonth,
    }
    setState(updatedState)
    onChange && onChange(updatedState)
  }, [onChange, state])

  const handleYearChange = useCallback(expiredYear => {
    const updatedState = {
      ...state,
      expiredYear,
    }
    setState(updatedState)
    onChange && onChange(updatedState)
  }, [onChange, state])

  const buildMenuItemList = useCallback(item => (
    <MenuItem key={item.value} value={item.value}>
      {item.text}
    </MenuItem>
  ), [])

  return (
    <Grid gap={0} fluid justify="center" className="mg-r-0 mg-l-0">
      <GridItem span={5}>
        <Dropdown
          menuAutoWidth
          name={`${name}.expiredMonth`}
          value={state.expiredMonth}
          onChange={handleMonthChange}
          onBlur={onBlur}
          hasError={hasError.expiredMonth}
          placeholder={i18n('passport.lib.components.newCreditCard.placeholder.month')}
          aria-label="ExpiredMonthDropdown"
        >
          <MenuItemList>
            {monthData.map(buildMenuItemList)}
          </MenuItemList>
        </Dropdown>
        <FormFieldError name={`${name}.expiredMonth`} />
      </GridItem>
      <GridItem span={2}>
        <Grid justify="center" align="center">
          <GridItem span={5}>/</GridItem>
        </Grid>
      </GridItem>
      <GridItem span={5}>
        <Dropdown
          menuAutoWidth
          name={`${name}.expiredYear`}
          value={state.expiredYear}
          onChange={handleYearChange}
          onBlur={onBlur}
          hasError={hasError.expiredYear}
          placeholder={i18n('passport.lib.components.newCreditCard.placeholder.year')}
          aria-label="ExpiredYearDropdown"
        >
          <MenuItemList>
            {yearData.map(buildMenuItemList)}
          </MenuItemList>
        </Dropdown>
        <FormFieldError name={`${name}.expiredYear`} />
      </GridItem>
    </Grid>
  )
})

ExpiredDateInput.defaultProps = {
  initialValue: { expiredMonth: '', expiredYear: '' },
}

export default ExpiredDateInput
